<template>
  <v-card id="pass40" class="ep-rechner-box">
    <v-col cols="12" class="p-0">
      <div class="v-card__title p-0">
        <h2 class="v-card--head--title">{{ selectedLang.ResultTile7 }}</h2>
      </div>
    </v-col>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <div class="v-card--msg">
            <h2 class="ep-rechner-h2 pb-7" v-html="resultMessage"></h2>
            <h3 class="ep-rechner-h3"><span class='ansprtext'>{{ selectedLang.ResultTile15ac }}</span></h3>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="dataEP.anspr == '213' || dataEP.anspr == '225'">
        <v-col cols="12">
          <v-hover v-slot:default="{ hover }">
            <v-div class="infoHover">
              <v-btn text block color="primary">{{
                selectedLang.ResultTile9
                }}</v-btn>
              <v-expand-transition>
                <v-div v-if="hover" class="d-flex transition-fast-in-fast-out text-center" style="height: 100%">{{
                  selectedLang.ResultTile10 }}</v-div>
              </v-expand-transition>
            </v-div>
          </v-hover>
        </v-col>
      </v-row>
      <v-row v-if="(kiofCla == 'TRF' || kiofCla == 'TRFDB') && !sent" class="tooltipbox tooltipbox-result">
        <v-col cols="12" sm="6">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn x-small color="#022c54" fab dark v-bind="attrs" v-on="on">
                <v-icon dark> mdi-help </v-icon>
              </v-btn>
            </template>
            <span v-html="resultTile15b"></span>
          </v-tooltip>
        </v-col>
      </v-row>
      <template v-if="newAGB">
        <v-form ref="nagform" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="clientMail" :rules="emailRules" :disabled="sent"
                :label="selectedLang.ResultTile18"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-row v-if="selectedDiv == '40' && !sent">
        <v-col cols="12">
          <v-btn v-if="!newAGB" id="confirm-tarif-refund" block class="btn-ep-next-step" @click="check40">{{ btnTextDi
            }}</v-btn>
          <v-btn v-if="newAGB" id="confirm-tarif-refund" block :disabled="sent" class="btn-ep-next-step"
            @click="saveNAW">{{
              btnTextNA }}</v-btn>
        </v-col>
      </v-row>

      <v-row v-if="selectedDiv != '40' && !noChange">
        <v-col cols="12">
          <v-btn id="goto--tarif-refund" block class="btn-ep-back-to" @click="backOnResult()">{{
            selectedLang.ResultTile16
            }}</v-btn>
        </v-col>
      </v-row>

      <v-row v-if="sent">
        <v-col cols="12">
          <v-btn block class="btn-ep-next-step" @click="check32">{{
            selectedLang.RejectionTile2
            }}</v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
export default {
  name: "ResultTile",
  data: function () {
    return {
      clientMail: "",
      sent: false,
      transferMessage: false,
      successMessage: this.$store.state.selectedLang.ResultTile21,
      errorMessage: this.$store.state.selectedLang.ResultTile2,
      resultMessage: "",
      btnTextW9: "",
      btnTextDi: "",
      btnTextNA: "",
      resultTile15b: "",
    };
  },
  mounted: function () {
    if (this.kiofCla == "TRF") {
      this.resultTile15b = this.selectedLang.ResultTile15b;
      if (this.newAGB) {
        this.resultMessage = this.formatDBText(this.selectedLang.ResultTile17, {
          "dataEP.refund": this.dataEP.refund,
          "dataEP.anspr": this.dataEP.anspr,
        });
        this.btnTextNA = this.selectedLang.ResultTile20;
      } else {
        this.resultMessage =
          this.selectedLang.ResultTile15aa +
          "<br><br><span class='anspr'>" +
          this.dataEP.anspr +
          " €" +
          "</span><br><span class='ansprtext'>";
        if (this.dataEP.ust == "0,00") {
          this.resultMessage =
            this.resultMessage +
            this.formatDBText(this.selectedLang.ResultTile15ad, {
              "dataEP.refund": this.dataEP.refund,
              "dataEP.provi": this.dataEP.provi,
              "dataEP.anspr": this.dataEP.anspr,
            }) +
            "</span>";
        } else {
          this.resultMessage =
            this.resultMessage +
            this.formatDBText(this.selectedLang.ResultTile15ab, {
              "dataEP.refund": this.dataEP.refund,
              "dataEP.provi": this.dataEP.provi,
              "dataEP.ust": this.dataEP.ust,
              "dataEP.anspr": this.dataEP.anspr,
            }) +
            "</span>";
        }
        this.btnTextW9 = this.selectedLang.ResultTile15d;
        this.btnTextDi = this.selectedLang.ResultTile15e;
      }
    } else if (this.kiofCla == "TRFDB") {
      this.resultTile15b = this.selectedLang.ResultTile15bDB;
      this.resultMessage = this.selectedLang.ResultTile15aaDB +
        "<br><br><span class='anspr'>" +
        this.dataEP.anspr +
        " €" +
        "</span><br><span class='ansprtext'>" +
        this.formatDBText(this.selectedLang.ResultTile15ab, {
          "dataEP.refund": this.dataEP.refund,
          "dataEP.provi": this.dataEP.provi,
          "dataEP.ust": this.dataEP.ust,
          "dataEP.anspr": this.dataEP.anspr,
        }) +
        "</span>";
      this.btnTextDi = this.selectedLang.ResultTile15e;
    } else {
      this.resultMessage = this.formatDBText(this.selectedLang.ResultTile15f, {
        synFludUnR: this.synFludUnR,
        "dataEP.anspr": this.dataEP.anspr,
      }) + "<br><br><span class='anspr'>" + this.formatDBText(this.selectedLang.ResultTile15fa, {
        "dataEP.anspr": this.dataEP.anspr,
      }) +
        "</span><br><span class='ansprtext'>" + this.formatDBText(this.selectedLang.ResultTile15g, {
          "dataEP.refund": this.dataEP.refund,
          "dataEP.provi": this.dataEP.provi,
          "dataEP.ust": this.dataEP.ust,
          "dataEP.anspr": this.dataEP.anspr,
        }) + "</span>";
      this.btnTextW9 = this.selectedLang.ResultTile14;
      this.btnTextDi = this.selectedLang.ResultTile15;
    }
  },
  computed: {
    ...mapState([
      "selectedDiv",
      "dataEP",
      "dataFS",
      "pass40",
      "emailRules",
      "flN",
      "flD",
      "noChange",
      "synFludUnR",
      "selectedLang",
      "kiofCla",
      "newAGB",
      "selectedCase"
    ]),
  },
  methods: {
    ...mapActions([
      "backToSpecificTile",
      "goToStep",
      "setSelectedDiv",
      "setVar",
      "killRun",
    ]),
    saveNAW() {
      if (this.$refs.nagform.validate()) {
        this.transferMessage = true;
        if (this.sendDataWAGB()) {
          this.sent = true;
          this.resultMessage = this.successMessage;
          this.setVar({ pos: "noChange", val: true });
        } else {
          this.resultMessage = this.errorMessage;
        }
      }
    },
    check40() {
      if (this.selectedCase.valN == 4 || this.selectedCase.valN == 7) {
        this.setSelectedDiv("50");
      } else {
        this.setSelectedDiv("24");
      }
      // this.setSelectedDiv("50");
      this.setVar({ pos: "pass40", val: true });
      this.goToStep({ vm: this, val: this.selectedDiv });
      this.$gtag.event("6a. Direkte Entschaedigung angefragt", {
        event_category: "Rechner",
        event_label: "6a. Direkte Entschaedigung angefragt",
      });
    },
    backOnResult() {
      this.backToSpecificTile("40");
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    async sendDataWAGB() {
      await axios
        .post(
          "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/sendDataWAGB.php",
          {
            flD: this.flD,
            flN: this.flN,
            anspr: this.dataEP.anspr,
            clientMailWAGB: this.clientMail,
            startAirtport: this.dataFS.airports.airportSC,
            targetAirtport: this.dataFS.airports.airportTC,
          }
        )
        .then((response) => {
          if (response.data.res == "200") {
            return true;
          } else {
            return false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    check32() {
      this.killRun({ vm: this });
    },
  },
};
</script>
